// http://crawler.sangerbox.com/api/plugin/getPublishedArticles
// https://api.sangerbox.com/fargroups_api/api/plugin/getPublishedArticles
const API_BASE_URL = "https://api.sangerbox.com/fargroups_api/api";

/**
 * 获取已发布的文章列表
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页码（从1开始）
 * @param {number} params.limit - 每页条数
 * @param {string[]} params.jcr - 期刊名称数组 目前有两个 ["CURRENT MOLECULAR PHARMACOLOGY","CURRENT PHARMACEUTICAL ANALYSIS"]
 * @param {string} params.order - "cite" //cite就是文章按照引用排序，为空就是按时间排序
 * @param {number[]} params.years - 2025 当前年份
 * @param {string} params.opt - issue（返回某一期的文章） issuelist（返回期卷列表 首页侧边栏） nomal （返回文章列表）
 * @param {string} params.vol - opt=issue时携带
 * @param {string} params.issued - opt=issue时携带
 * @returns {Promise<any>} 接口返回的数据
 */
export async function getPublishedArticles({
  page,
  limit,
  jcr,
  order,
  years,
  opt,
  vol,
  issued,
}) {
  const url = `${API_BASE_URL}/plugin/getPublishedArticles`;

  const payload = {
    jcr: jcr,
    page: page,
    limit: limit,
    order: order,
    years: years,
    opt: opt || "",
  };

  // 只有在 opt === "issue" 时才添加 vol 和 issue
  if (opt === "issue") {
    payload.vol = vol || "";
    payload.issued = issued || "";
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`请求失败: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API 请求错误:", error);
    throw error;
  }
}

const UNSUBSCRIBE_URL = "https://api.sangerbox.com/fargroups_api/api/mail/unsubscribe";

/**
 * 邮件退订
 * @param {Object} params
 * @param {string} params.email
 * @param {string} params.code
 * @param {number} [timeoutMs=40000]
 * @returns {Promise<{msg: number, email?: string}>}
 */
export async function unsubscribeMail({ email, code, timeoutMs = 40000 }) {
  const url = `${UNSUBSCRIBE_URL}?${new URLSearchParams({ email, code })}`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, {
      method: "GET",
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`请求失败: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      const timeoutError = new Error("Request timed out");
      timeoutError.name = "TimeoutError";
      throw timeoutError;
    }
    console.error("Unsubscribe API 请求错误:", error);
    throw error;
  } finally {
    clearTimeout(timer);
  }
}
